import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import '@/utils/transform.js';
import Transform from '@/utils/transform.ts';
import AlloyTouch from 'alloytouch';
import PackageSwiper from '@/components/Swiper/PackageCard';

import './style.less';

interface IMyFocus {
  dataSource?: any;
  events?: any;
  priceType?: number
  deviceType?: number
}

@Component
export default class MyFocus extends tsx.Component<IMyFocus> {
  
  @Prop() dataSource?: any
  @Prop() events?: any
  @Prop() priceType?: number
  @Prop() deviceType?: any
  
  data() {
    return {
      activeIndex: 1,
      length: 2
    }
  }
  
  mounted() {
    console.log('newMyFocus')
    this.newMyFocus({})
  }
  
  newMyFocus(basicData) {
    const {
      initialSlide = 0, //设定初始化时slide的索引。
      loop = false, //是否循环
      pagination = false,
      paginationEl = '#nav a',
      perViewEl = '.device-container',
      scrollerEl = '#carousel-scroller2',
      containerEl = '#carousel-container2' // //反馈触摸的dom
    } = basicData
    
    this.initMyFocus({
      initialSlide,
      loop,
      pagination,
      paginationEl,
      perViewEl,
      scrollerEl,
      containerEl
    })
  }
  
  getEl(basicData) {
    return {
      items: document.querySelectorAll(basicData.paginationEl),
      scroller: this.$refs.scroller,
      slides: document.querySelectorAll(basicData.perViewEl)
    }
  }
  
  initMyFocus(basicData) {
    const {scroller} = this.getEl(basicData)
    Transform(scroller);
    let myFocus = new AlloyTouch({
      touch: this.$refs.carousel,
      vertical: false,//不必需，默认是true代表监听竖直方向touch
      target: scroller, //运动的对象
      property: 'translateX',  //被运动的属性
      min: window.innerWidth * -3, //不必需,运动属性的最小值
      max: 0, //不必需,滚动属性的最大值
      step: window.innerWidth,
      spring: true, //不必需,是否有回弹效果。默认是true
      inertia: true, //不必需,是否有惯性。默认是true
      touchEnd: (evt, v, index) => this.touchEnd(evt, v, index, myFocus),
      animationEnd: (evt, v) => this.animationEnd(evt, v, myFocus)
    })
    
    myFocus.to((basicData.initialSlide + 1) * myFocus.step * -1 + myFocus.step);
    
  }
  
  animationEnd(evt, v, myFocus) {
    this.$data.activeIndex = myFocus.currentPage;
    this.$props.events.swiperOnChange(myFocus.currentPage +  1)
  }
  
  touchEnd(evt, v, index, myFocus, ) {
    const min = this.$props.priceType === 1 ? window.innerWidth * -2 : 0
    let step_v = index * myFocus.step * -1;
    let dx = v - step_v;
    if(v < min) {
      myFocus.to(min);
    } else if(v > myFocus.max) {
      myFocus.to(myFocus.max);
    } else if(Math.abs(dx) < 30) {
      myFocus.to(step_v);
    }
    else if(dx > 0) {
      if (index === 0) {
        myFocus.to(0);
  
      } else {
        myFocus.to(step_v + myFocus.step);
      }
    } else {
      if (index >= this.$data.length) {
        myFocus.to(this.$data.activeIndex * myFocus.step * -1);
        return false
      }
      myFocus.to(step_v - myFocus.step);
    }
    return false;
  }
  
  getJustifyContent (index: number) {
    const {activeIndex} = this.$data;
    if (activeIndex === index) {
      return ''
    }
    if (activeIndex < index) {
      return 'container-left'
    }
    return 'container-right'
  }
  
  render() {
    const {events, deviceType} = this.$props;
    let dataSource = this.$props.priceType === 1 ? [0,1,2] : [[0,1,0,2][deviceType]]
    return (
      <div ref="carousel" id="carousel-container2">
        <div class="background"></div>
        <div class="carousel">
          <div ref="scroller" style={`width: 300%`} class="carousel-scroller" id="carousel-scroller2">
            {dataSource.map((key, index) => {
              return (
                <div class="slide">
                  <div class={`${this.$data.activeIndex === key ? 'item' : 'item2'} ${this.getJustifyContent(index)}`}>
                    <PackageSwiper type={key}/>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {this.$props.priceType == 1 ?
          <div class="swiper-pagination">
            {dataSource.map((key) => (<div class={`dot ${this.$data.activeIndex === key && 'active'}`}></div>))}
          </div> : null
        }
      </div>
    )
  }
  
}